/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseDto } from './CaseDto';
import {
    CaseDtoFromJSON,
    CaseDtoFromJSONTyped,
    CaseDtoToJSON,
    CaseDtoToJSONTyped,
} from './CaseDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CaseResponse
 */
export interface CaseResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof CaseResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CaseResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CaseResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {CaseDto}
     * @memberof CaseResponse
     */
    data?: CaseDto;
}

/**
 * Check if a given object implements the CaseResponse interface.
 */
export function instanceOfCaseResponse(value: object): value is CaseResponse {
    return true;
}

export function CaseResponseFromJSON(json: any): CaseResponse {
    return CaseResponseFromJSONTyped(json, false);
}

export function CaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : CaseDtoFromJSON(json['data']),
    };
}

export function CaseResponseToJSON(json: any): CaseResponse {
    return CaseResponseToJSONTyped(json, false);
}

export function CaseResponseToJSONTyped(value?: CaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': CaseDtoToJSON(value['data']),
    };
}

